import { defineMessages } from 'react-intl';

const CommonMessages = defineMessages({
  submit: {
    id: 'submit',
    defaultMessage: 'Submit',
    description: 'A submit button'
  },
  reset: {
    id: 'reset',
    defaultMessage: 'Reset',
    description: 'A reset button'
  },
  required: {
    id: 'error.required',
    defaultMessage: '{fieldName} is required',
    description: 'Error message to display when a field is required'
  },
  tooShort: {
    id: 'error.tooShort', 
    defaultMessage: '{fieldName} must be eight characters or longer',
    description: 'Error message to display when a value is too short'
  },
  save: {
    id: 'save',
    defaultMessage: 'Save',
    description: 'A save button'
  },
  edit: {
    id: 'edit',
    defaultMessage: 'Edit',
    description: 'An edit button'
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel',
    description: 'A cancel button'
  }
});

export default CommonMessages;



// WEBPACK FOOTER //
// ./src/intl/CommonMessages.js